<template>
    <div class="horizSpaced">
        <div class="bordered darkgreen">
            <div>
                <label class="titletext">{{dataList[0].name}}</label>
                <div class="twocols">
                    <summarybox :amount="dataList[1].amount" :count="dataList[1].count" :title="dataList[1].name" background="green" v-if="dataList[1].count>0"/>
                    <summarybox :amount="dataList[2].amount" :count="dataList[2].count" :title="dataList[2].name"  background="green" v-if="dataList[2].count>0"/>
                    <summarybox :amount="dataList[13].amount" :count="dataList[13].count" :title="dataList[13].name"  background="green" v-if="dataList[13].count>0"/>
                    <summarybox :amount="dataList[14].amount" :count="dataList[14].count" :title="dataList[14].name"  background="green" v-if="dataList[14].count>0"/>
                    <summarybox :amount="dataList[15].amount" :count="dataList[15].count" :title="dataList[15].name"  background="green" v-if="dataList[15].count>0"/>
                    <summarybox :amount="dataList[16].amount" :count="dataList[16].count" :title="dataList[16].name"  background="green" v-if="dataList[16].count>0"/>
                </div>
            </div>
            
            <div class="flexSpace">
                <label class="titletext">{{dataList[0].count}} {{dataList[0].name}}</label>
                <label class="titletext"> - {{dataList[0].amount | toCurrency}}</label>
            </div>
        </div>

        <div class="bordered darktan">
            <div>
                <label class="titletext">{{dataList[19].name}}</label>
                <div class="twocols">
                    <summarybox :amount="dataList[18].amount" :count="dataList[18].count" :title="dataList[18].name" background="tan"/>
                    <summarybox :amount="dataList[21].amount" :count="dataList[21].count" :title="dataList[21].name" background="tan" v-if="dataList[21].count>0"/>
                </div>
            </div>
            
            
            <div class="flexSpace">
                <label class="titletext">{{dataList[19].count}} {{dataList[19].name}}</label>
                <label class="titletext"> - {{dataList[19].amount | toCurrency}}</label>
            </div>
        </div>

        <div class="bordered darkred">
            <div>
                <label class="titletext">{{dataList[20].name}}</label>
                <div class="twocols">
                    <!-- <summarybox :amount="dataList[7].amount" :count="dataList[7].count" :title="dataList[7].name"  background="red"/> -->
                    
                    <summarybox :amount="dataList[17].amount" :count="dataList[17].count" :title="dataList[17].name"  background="red"/>
                    <summarybox :amount="dataList[10].amount" :count="dataList[10].count" :title="dataList[10].name" background="red"/>
                    <summarybox :amount="dataList[11].amount" :count="dataList[11].count" :title="dataList[11].name" background="red"/>
                </div>
            </div>
            
            
            <div class="flexSpace">
                <label class="titletext">{{dataList[20].count}} {{dataList[20].name}}</label>
                <label class="titletext"> - {{dataList[20].amount | toCurrency}}</label>
            </div>
        </div>

        
      
    </div>
  
</template>

<script>
import format from '../../format.js'
import summarybox from '../controls/summarybox.vue'
export default {
    name:'summary_trucktrack',   
    props:{
        dataList:{
            type:Array,
            
        },

    },  
    computed:{

    },
    mixins:[format],
    components:{
        summarybox
    }

}
</script>

<style scoped>

.boxed{
    border:darkgray 1px solid;
    display:flex;
    flex-direction: column;
    padding:10px;
    margin:5px;
}
.bordered{
    border-radius:10px;
    display:flex;
    flex-direction: column;
    justify-content:space-between;
    padding:15px;
    margin-right:20px;
}
.darkgreen{
    background-color:rgb(61,118,81);
}

.darkblue{
    background-color:rgb(79,118,221);
}

.darkred{
    background-color:rgb(197, 101, 101);
}

.darktan{
    background-color:rgb(218, 175, 77);
}

.titletext{

    color:white;
}
.flexwrap{
    display:flex;
    flex-direction: row;
    
}
.twocols{
    display:flex;
    flex-direction: row;
    justify-content: center;
    max-width:500px;
    flex-wrap: wrap;
}
.horizSpaced{
 width:97vw;
  display:flex;
  flex-direction: row;
  
  margin:0px;
  justify-content: space-between;
  flex-wrap:wrap;
}
.itemDiv{
 
    display:grid;
    width:100vw;
    grid-template-columns:repeat(4,1fr);
    grid-template-rows:auto auto auto auto;
    margin-bottom:3px;
    text-align: left;
 
}
label{
 
    margin-right:5px;
    min-width:160px;
}
.pair{
    display:flex;
    flex-direction: row;
}
.right{
    text-align: right;
    min-width: 80px;
}
</style>